import { Injectable } from '@angular/core';
import { Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { ClientRepositoryBase } from '@skylab-shared/business';
export { ClientRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(ClientRepositoryBase)
export class ClientRepository {
    public constructor(
        weaver: Weaver,
        queryBus: QueryBus,
        http: Http
    ) { }
}
